<template>
  <a-modal
    :visible="isOpen"
    width="90%"
    title="Shipment Sum"
    @cancel="$emit('onModalClose')"
    :footer="null"
  >
    <div class="modal">
      <div class="s-filter-box">
        <a-form layout="inline">
          <a-form-item label="Plan Pickup Date">
            <a-range-picker
              class="range-w"
              v-model:value="dateRange"
              valueFormat="YYYY-MM-DD"
            />
          </a-form-item>

          <a-form-item>
            <a-button type="primary" @click="find">
              <template #icon><SearchOutlined /></template>
              Find
            </a-button>
          </a-form-item>
        </a-form>
        <div class="btn-right">
          <a-button type="link" @click="doload()">Export</a-button>
        </div>
      </div>
      <a-table
        :columns="columns"
        :row-key="(record) => record.id"
        :data-source="shipmentSumItems"
        :loading="loading"
        :scroll="{ x: '200%', y: 'auto' }"
        size="small"
      ></a-table>
    </div>
  </a-modal>
</template>
<script setup>
  import { defineProps, ref, watchEffect } from 'vue'
  import request from '@/utils/request'
  import { SearchOutlined } from '@ant-design/icons-vue'
  import { baseURL } from '@/config'
  import dayjs from 'dayjs'
  const props = defineProps({
    isOpen: Boolean,
    currentSystem: Number,
  })
  const dateRange = ref([
    dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
    dayjs().add(3, 'month').format('YYYY-MM-DD'),
  ])

  const doload = () => {
    let url = `${baseURL}/api/shipment/exportShipmentSum?current-system=${
      props.currentSystem
    }&start=${dayjs(dateRange.value[0]).valueOf()}&end=${
      dayjs(dateRange.value[1]).add(1, 'day').valueOf() - 1
    }`
    window.location.href = url
  }
  const columns = ref([
    {
      title: 'No',
      dataIndex: 'no',
      key: 'no',
      fixed: true,
      customRender({ index }) {
        return index + 1
      },
      width: '5%',
    },

    {
      title: 'Plan PickupDate',
      dataIndex: 'planPickupDate',
      width: '10%',
      customRender({ text }) {
        return dayjs(text).format('YYYY/MM/DD')
      },
    },
    {
      title: 'net_Grp',
      dataIndex: 'netGrp',
      width: '10%',
    },
    {
      title: 'SRI Status',
      dataIndex: 'sriStauts',
      width: '10%',
      customRender({ text }) {
        return text ? 'Released' : 'Not Released'
      },
      customCell: (record) => {
        return {
          class: record.sriStauts ? '' : 'danger',
        }
      },
    },
    {
      title: 'OFS Owner',
      dataIndex: 'shipRequestor',
      width: '10%',
    },
    {
      title: 'Model Name',
      dataIndex: 'modelName',
      width: '10%',
    },
    {
      title: 'System Job ID',
      dataIndex: 'jobId',
      width: '15%',
    },
    {
      title: 'PO#',
      dataIndex: 'customerPoNo',
      width: '10%',
    },
    {
      title: 'Ship to Country',
      dataIndex: 'toCountry',
      width: '10%',
    },
    {
      title: 'Forwarder Status',
      dataIndex: 'forwarderStauts',
      width: '10%',
      customRender({ text }) {
        return text ? 'Arrived' : 'Not Arrived'
      },
      customCell: (record) => {
        return {
          class: record.forwarderStauts ? '' : 'danger',
        }
      },
    },
    {
      title: 'Route ID',
      dataIndex: 'rsdsReqPickupDate',
      width: '10%',
    },
    {
      title: 'RSDS',
      dataIndex: 'routeId',
      width: '10%',
      customRender({ text }) {
        return dayjs(text).format('YYYY/MM/DD')
      },
    },
    {
      title: 'System Job Status',
      dataIndex: 'jobStatus',
      width: '15%',
    },
    {
      title: 'Gap',
      dataIndex: 'gap',
      width: '10%',
      customRender({ text }) {
        return Math.round((text / 3600000) * 100) / 100
      },
      customCell: (record) => {
        return {
          class: record.gap < 0 ? 'danger' : '',
        }
      },
    },
    {
      title: 'System Job eEnd/aEnd',
      dataIndex: 'eEnd',
      width: '15%',
      customRender({ text }) {
        return dayjs(text).format('YYYY/MM/DD')
      },
    },
    {
      title: 'Option Status',
      dataIndex: 'optionStatus',
      width: '10%',
    },
    {
      title: 'Option Number',
      dataIndex: 'optionNumber',
      width: '10%',
    },
    {
      title: 'Remark',
      dataIndex: 'remark',
      width: '10%',
    },
    {
      title: 'fgName',
      dataIndex: 'fgName',
      width: '10%',
    },
  ])
  const loading = ref(false)
  const shipmentSumItems = ref([])
  const find = () => {
    loading.value = true
    request({
      url: '/api/shipment/shipmentSum',
      params: {
        start: dayjs(dateRange.value[0]).valueOf(),
        end: dayjs(dateRange.value[1]).valueOf(),
      },
    })
      .then((res) => {
        shipmentSumItems.value = res.body
      })
      .finally(() => {
        loading.value = false
      })
  }
  watchEffect(() => {
    if (props.isOpen) {
      find()
    }
  })
</script>
<style lang="less" scoped>
  .modal {
    height: calc(100vh - 260px);
    overflow: auto;
  }
  .s-filter-box {
    padding: 10px;
    background: #f2f3f5;
    border-bottom: 1px solid #dbdcdc;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  :deep(.ant-table) {
    .danger {
      color: #f7513c;
    }
  }
</style>
